import {Checkbox, FormControlLabel, TextFieldProps} from '@mui/material';
import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import {getValueFromNestedObject} from "../../../../utils/langUtils.ts";

type CheckboxInputProps = {
    name: string;
    label: string;
} & TextFieldProps;

const FormCheckbox: FC<CheckboxInputProps> = ({ name, label, ...otherProps }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const error = getValueFromNestedObject(errors, name)
    
    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <FormControlLabel
                    {...field}
                    control={
                        <Checkbox {...otherProps}/>
                    }
                    margin="normal"
                    variant="standard"
                    label={label}
                    labelPlacement='end'
                    checked={field.value}
                    onChange={(e) => field.onChange(e.target.checked)}
                    helpertext={
                        error ? (error?.message as unknown as string) : ''
                    }
                />
            )}
        />
    );
};

export default FormCheckbox;
